import PriceText from '../PriceText/index.vue';
import SalesKicker from '../SalesKicker/index.vue';

export default {
  name: 'PriceWrapper',
  data() {
    return {
      className: 'app__product__price__wrapper',
      jsId: 'js__product__price',
    };
  },
  computed: {
    mainPriceClassName() {
      return `${this.className}__main`;
    },
    discountClassName() {
      return `${this.mainPriceClassName}--discount`;
    },
    jsDiscountId() {
      return `${this.jsId}__discount`;
    },
    jsMainPriceId() {
      return `${this.jsId}__main`;
    },
    jsPriceFlagId() {
      return `${this.jsId}__flag`;
    },
  },
  props: {
    price: {
      type: String,
      default: '',
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    salePrice: {
      type: String,
      default: '',
    },
    showSalePrice: {
      type: Boolean,
      default: false,
    },
    savings: {
      type: String,
      default: '',
    },
    showSavings: {
      type: Boolean,
      default: false,
    },
    translations: String,
  },
  components: {
    PriceText,
    SalesKicker,
  },
};
